<template>
  <q-card flat bordered>
    <div
      class="q-pa-sm text-center text-body1 text-bold text-bold"
      :class="this.$q.dark.mode ? '' : 'text-primary'"
    >
      Top Gainers
    </div>
    <q-separator />
    <q-table
      :dense="$q.screen.xs"
      class="text-caption"
      :class="
        this.$q.dark.mode === true
          ? 'table-sticky-header-column-dark'
          : tablethreadColor()
      "
      flat
      :pagination="paginationTopGainers"
      :rows="filterTableSeriesDataForGainers"
      :columns="
        isMarketOn
          ? columnsTopGainers
          : tabPeriod == 'daily'
          ? columnsTopGainersDaily
          : tabPeriod == 'weekly'
          ? columnsTopGainersWeekly
          : tabPeriod == 'monthly'
          ? columnsTopGainersMonthly
          : []
      "
      binary-state-sort
      separator="cell"
    >
      <template v-slot:body-cell-symbol="props">
        <q-td :props="props" style="padding: 4px">
          <q-item
            dense
            class="row"
            style="cursor: pointer"
            clickable
            :to="{
              path: '/stock-profile',
              query: { symbol: props.value },
            }"
          >
            <div class="col">
              {{ props.value }}
              <q-tooltip>{{
                allStocks.find((stock) => stock.symbol == props.value)?.name
              }}</q-tooltip>
            </div>
            <!-- <div
              style="font-size: 12px; margin-left: -30px"
              v-if="
                (props.row.point_change ||
                  props.row.point_change_weekly ||
                  props.row.point_change_monthly) &&
                (props.col.name == 'point_change' ||
                  props.col.name == 'point_change_weekly' ||
                  props.col.name == 'point_change_monthly')
              "
              class="col q-mt-md"
            >
              {{
                tabPeriod == "daily"
                  ? props.row.percentage_change.toFixed(2)
                  : tabPeriod == "weekly"
                  ? props.row.percentage_change_weekly.toFixed(2)
                  : tabPeriod == "monthly"
                  ? props.row.percentage_change_monthly.toFixed(2)
                  : ""
              }}%
            </div> -->
          </q-item>
        </q-td>
      </template>
    </q-table>
  </q-card>
</template>

<script>
import { ref, watch } from "vue";

import useData from "src/use/data";
import useCore from "src/use/core";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import useUtils from "src/use/utils";

export default {
  name: "TopGainers",

  props: {
    isMarketOn: {
      type: Boolean,
      required: false,
      default: false,
    },
    tabPeriod: { type: String, required: false },
    filterTableSeriesDataForGainers: {
      type: Array,
      required: false,
    },
    sectorId: {
      type: Number,
      required: false,
      default: null,
    },
    allStocks: {
      type: Array,
    },
    topGainers: { type: Array },
    topGainersDaily: { type: Array },
    topGainersWeekly: { type: Array },
    topGainersMonthly: { type: Array },
  },

  setup(props) {
    const { allStock } = useCore();

    const filterTopGainers = ref("");

    const filterStockData = ref([]);
    const tableSeriesData = ref([]);

    const stocks = ref([]);
    const store = useStore();
    const $q = useQuasar();
    const { chooseTabColor } = useUtils();

    function tablethreadColor() {
      return chooseTabColor($q.dark.mode, store.state.domain.domain);
    }
    const chooseTitleColor = tablethreadColor.bind(null);

    const columnsTopGainers = [
      {
        name: "symbol",
        label: "Symbol",
        field: "symbol",
        sortable: true,
        align: "center",
        style: "min-width:20px;max-width:20",
        classes: "ellipsis",
      },
      {
        name: "LTP",
        label: "LTP",
        field: "close",
        sortable: true,
        align: "center",
      },
      // {
      //   name: "previous_LTP",
      //   label: "Prev LTP",
      //   field: "prev_close",
      //   sortable: true,
      //   align: "center",
      // },
      {
        name: "point_change",
        label: "P.CH",
        field: "point_change",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.point_change) > 0 ? "color:green" : "color:red";
        },
        align: "center",
      },
      {
        name: "percentage_change",
        label: "CH%",
        field: "percentage_change",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.percentage_change) > 0
            ? "color:green"
            : "color:red";
        },
        align: "center",
      },
      {
        name: "amount",
        label: "Amt(Cr)",
        field: "amount",
        sortable: true,
        format: (val, row) => {
          return (parseFloat(val) / 10000000).toFixed(2);
        },
        align: "center",
      },
    ];

    const columnsTopGainersDaily = [
      {
        name: "symbol",
        label: "Symbol",
        field: "symbol",
        align: "center",

        classes: "ellipsis",
      },
      {
        name: "close",
        label: "LTP",
        field: "close",
        sortable: true,
        align: "center",
      },
      // {
      //   name: "prev_close",
      //   label: "Prev LTP",
      //   field: "prev_close",
      //   sortable: true,
      //   align: "center",
      // },
      {
        name: "point_change",
        label: "P.CH",
        field: "point_change",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.point_change) > 0 ? "color:green" : "color:red";
        },
        align: "center",
      },

      {
        name: "percentage_change",
        label: "CH%",
        field: "percentage_change",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.percentage_change) > 0
            ? "color:green"
            : "color:red";
        },
        align: "center",
      },
      {
        name: "amount",
        label: "Amt(Cr)",
        field: "amount",
        sortable: true,
        format: (val, row) => {
          return (parseFloat(val) / 10000000).toFixed(2);
        },
        align: "center",
      },
      {
        name: "amount_change_daily",
        label: "Amt.CH %",
        field: "amount_change_daily",
        align: "center",
        sortable: true,
        style: "max-width: 10px",
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.amount_change_daily) > 0
            ? "color:green"
            : "color:red";
        },
      },
    ];
    const columnsTopGainersWeekly = [
      {
        name: "symbol",
        label: "Symbol",
        field: "symbol",
        align: "center",
        style: "min-width: 50px;padding:0px",
        classes: "ellipsis",
      },
      {
        name: "close",
        label: "LTP",
        field: "close",
        sortable: true,
        align: "center",
      },
      // {
      //   name: "prev_close_weekly",
      //   label: "Prev LTP",
      //   field: "prev_close_weekly",
      //   sortable: true,
      //   align: "center",
      // },
      {
        name: "point_change_weekly",
        label: "P.CH",
        field: "point_change_weekly",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.point_change_weekly) > 0
            ? "color:green"
            : "color:red";
        },
        align: "center",
      },

      {
        name: "percentage_change_weekly",
        label: "CH%",
        field: "percentage_change_weekly",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.percentage_change_weekly) > 0
            ? "color:green"
            : "color:red";
        },
        align: "center",
      },
      {
        name: "amount_weekly",
        label: "Amt(Cr)",
        field: "amount_weekly",
        sortable: true,
        format: (val, row) => {
          return (parseFloat(val) / 10000000).toFixed(2);
        },
        align: "center",
      },
      {
        name: "amount_change_weekly",
        label: "Amt.CH %",
        field: "amount_change_weekly",
        align: "center",
        sortable: true,
        style: "max-width: 10px",
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.amount_change_weekly) > 0
            ? "color:green"
            : "color:red";
        },
      },
    ];
    const columnsTopGainersMonthly = [
      {
        name: "symbol",
        label: "Symbol",
        field: "symbol",
        align: "center",
        style: "min-width: 50px;padding:0px",
        classes: "ellipsis",
      },
      {
        name: "close",
        label: "LTP",
        field: "close",
        sortable: true,
        align: "center",
      },
      // {
      //   name: "prev_close_monthly",
      //   label: "Prev LTP",
      //   field: "prev_close_monthly",
      //   sortable: true,
      //   align: "center",
      // },
      {
        name: "point_change_monthly",
        label: "P.CH",
        field: "point_change_monthly",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.point_change_monthly) > 0
            ? "color:green"
            : "color:red";
        },
        align: "center",
      },

      {
        name: "percentage_change_monthly",
        label: "CH%",
        field: "percentage_change_monthly",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.percentage_change_monthly) > 0
            ? "color:green"
            : "color:red";
        },
        align: "center",
      },
      {
        name: "amount_monthly",
        label: "Amt(Cr)",
        field: "amount_monthly",
        sortable: true,
        format: (val, row) => {
          return (parseFloat(val) / 10000000).toFixed(2);
        },
        align: "center",
      },
      {
        name: "amount_change_monthly",
        label: "Amt.CH %",
        field: "amount_change_monthly",
        align: "center",
        sortable: true,
        style: "max-width: 10px",
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.amount_change_monthly) > 0
            ? "color:green"
            : "color:red";
        },
      },
    ];

    const paginationTopGainers = ref({
      sortBy: "percentage_change",
      descending: true,
      rowsPerPage: 10,
    });

    watch(props, (newProps, oldProps) => {
      // filterStockPerformanceDataBySector();
    });

    return {
      chooseTitleColor,
      tablethreadColor,
      columnsTopGainers,
      columnsTopGainersDaily,
      columnsTopGainersWeekly,
      columnsTopGainersMonthly,
      paginationTopGainers,

      filterTopGainers,

      filterStockData,
    };
  },
};
</script>
